import { useDesignLabPrices } from "@design-lab/entities/composition/model";
import { useArtworkForm } from "@design-lab/entities/artwork";
import { useEditMode } from "@design-lab/shared/hooks/useEditMode";
import {
  useFreeShippingThreshold,
  useIsFreeShippingThresholdZero
} from "@design-lab/shared/lib/config";
import { useAddToCartSubmit } from "./useAddToCartSubmit";

export function useCartSummary() {
  const { form } = useArtworkForm();
  const { placements } = useAddToCartSubmit();
  const { isEditMode, assemblyGroupId } = useEditMode();
  const freeShippingThreshold = useFreeShippingThreshold();
  const isFreeShippingThresholdZero = useIsFreeShippingThresholdZero();

  const activePlacements = placements.filter(placement => {
    const placementData = form.getValues(`${placement}`);
    return placementData && placementData.artworkId && placementData.size;
  });

  const placementsForPricing =
    activePlacements.length > 0
      ? activePlacements.filter(
          placement =>
            placement === "back" || placement === form.getValues("selectedFrontPlacement")
        )
      : ["front"];
  const { data: prices, isLoading } = useDesignLabPrices(
    placementsForPricing,
    isEditMode ? assemblyGroupId : undefined
  );

  // For footer display, we show the base pricing (this is simplified for the summary view)
  const originalPrice = prices?.preBulkDiscountPrice ?? 0;
  const salePrice = prices?.effectivePrice ?? 0;
  const savings = prices?.savings ?? 0;

  return {
    originalPrice,
    salePrice,
    savings,
    isLoading,
    freeShippingThreshold,
    isFreeShippingThresholdZero
  };
}
